export const mapGetApiFuel = (rawFuel: string): string => {
  if (!rawFuel) return ''
  const fuel = rawFuel.toUpperCase()
  if (fuel.includes('BENCINA') || fuel.includes('GASOLINA')) return 'FUEL.UNLEADED'
  if (fuel.includes('DIESEL')) return 'FUEL.DIESEL'
  if (fuel.includes('ELECTRIC')) return 'FUEL.ELECTRIC'
  if (fuel.includes('HIBRID')) return 'FUEL.HYBRID'
  if (fuel.includes('GAS')) return 'FUEL.NATURAL_GAS'
  return ''
}

export const mapGetApiTransmission = (rawTrans: string): string => {
  if (!rawTrans) return ''
  const trans = rawTrans.toUpperCase()
  if (trans.includes('AUTO')) return 'GEARBOX.AUTO'
  if (trans.includes('MANUAL')) return 'GEARBOX.MANUAL'
  return ''
}

export const mapGetApiColor = (rawColor: string): string => {
  if (!rawColor) return ''
  const color = rawColor.toUpperCase()
  // Map exact matches to translate enum keys
  const map: Record<string, string> = {
    AMARILLO: 'Amarillo',
    AZUL: 'Azul',
    BEIGE: 'Beige',
    BLANCO: 'Blanco',
    DORADO: 'Dorado',
    GRIS: 'Gris',
    MARRON: 'Marrón',
    CAFE: 'Marrón', // Add CAFE map
    NARANJA: 'Naranja',
    NEGRO: 'Negro',
    ROJO: 'Rojo',
    ROSA: 'Rosa',
    ROSADO: 'Rosa',
    VERDE: 'Verde',
    PLATA: 'Plata / Plateado',
    PLATEADO: 'Plata / Plateado',
  }

  // Try direct map
  if (map[color]) return map[color]

  // Try partial match
  for (const [key, value] of Object.entries(map)) {
    if (color.includes(key)) return value
  }

  return ''
}

export const mapGetApiType = (rawType: string): string => {
  if (!rawType) return ''
  const type = rawType.toUpperCase()
  if (type.includes('MOTO')) return 'TYPES.VEHICLE.MOTORCYCLE'
  if (
    type.includes('CAMIONETA') ||
    type.includes('SUV') ||
    type.includes('AUTO') ||
    type.includes('SEDAN') ||
    type.includes('HATCHBACK') ||
    type.includes('STATION')
  ) {
    return 'TYPES.VEHICLE.AUTOMOBILE' // Generalizamos autos/suv/camionetas al tipo base de Veekls
  }
  if (type.includes('CAMION')) return 'TYPES.VEHICLE.TRUCK'
  if (type.includes('BUS')) return 'TYPES.VEHICLE.BUS'
  if (type.includes('MAQUINARIA')) return 'TYPES.VEHICLE.MACHINERY'
  return 'TYPES.VEHICLE.AUTOMOBILE' // Default
}
